import styled from 'styled-components';

export const FormHeader = styled.h2`
  text-align: center;
`;

const Icon = styled.svg.attrs({
  version: '1.1',
  xmlns: 'http://www.w3.org/2000/svg',
})``;

export const Svg = styled(Icon)`
  width: 250px;
  display: block;
  margin: 0 auto;
`;
